<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>

<script>
const default_layout = "default";

export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + '-layout';
    }
  }
}
</script>

<style lang="scss">
#app {
  @apply font-principal text-principal-gray;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  overflow-x:hidden;
  a {
    text-decoration: none !important;
    &:hover{
      color: inherit;
    }
  }
  .container {
    @apply p-8;
  }
}

</style>
